import { useLayoutEffect, useState } from "react";

const useElementSize=(id:string)=> {
    const [size, setSize] = useState(0);
    useLayoutEffect(() => {
        function updateSize() {
            const element = document.getElementById(id);
            if(element){
                const height= window.innerHeight - element.offsetTop;
                setSize(height);
            }
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export default useElementSize;